import { render } from "./PdpProductPriceTooltip.vue?vue&type=template&id=bd0c168c"
import script from "./PdpProductPriceTooltip.vue?vue&type=script&lang=js"
export * from "./PdpProductPriceTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__